// axios
import axios from "axios";

export const CheckPaymentStatus = async (data: any) => {
    let ClientOption: any = {
        headers: {
            'APIKEY': "zPSBbzwkalFSRchnnZwfvbydZ8Qzs9ZepMGakIG9D7jEL5BtXyreJNypxDro",
        }
    };
    const { data: response } = await axios.post(`${process.env.REACT_APP_API_URL}user/payment/verify?success=${data.success}&status=${data.status}&trackId=${data.trackId}`, {}, ClientOption);
    console.log(response)
    return response;
}